import React from 'react'

import {
  Icon,
  Redirect,
  TagComponent,
} from '@cgtrader/triangle-ui/dist/src/ssr-index'

function LinksToTags({ tagLinks }) {
  if (!tagLinks || tagLinks.length === 0) {
    return null
  }

  return (
    <div className="col-12">
      <div className="links-to-printable">
        <h5 className="cgt-legacy-heading-h5 cgt-mb-20">{tagLinks.header}</h5>

        {tagLinks.links
          .map(({ link, title }) => (
            <a href={link} key={title} className="links-to-printable__link">
              <TagComponent
                key={title}
                color="grey"
                type="secondary"
                trailIcon={<Icon color="dark" svgComponent={Redirect} />}
              >
                {title}
              </TagComponent>
            </a>
          ))}
      </div>
    </div>
  )
}

export default LinksToTags
